<template>
    <div class="pt-4 col-sm-12">

        <div class="row">

            <div class="col-sm-6">
                <div class="tckBtn radius-normal pointer border-darker text-center d-flex flex-column justify-content-center" @click="getTickets(true)">
                    <div>
                        <div><i class="ico ico-print m-0 fs-super"></i></div>
                        <div class="font-weight-600 mt-2 fs-larger">Print Tickets</div>
                    </div>
                </div>
            </div>

            <div class="col-sm-6">
                <div class="tckBtn radius-normal pointer border-darker text-center d-flex flex-column justify-content-center" @click="getTickets(false)">
                    <div>
                        <div><i class="ico ico-email m-0 fs-super"></i></div>
                        <div class="font-weight-600 mt-2 fs-larger">Email Tickets</div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        created: function(){
        },
        props: {
            bulkObject: {
                type: Object
            }
        },
        data: function() {
            return {
            }
        },
        computed: {
            ...mapGetters([
                'account',
                'getBulkSelectedIds'
            ]),
        },
        methods: {
            ...mapActions([
                'closeModal'
            ]),
            getTickets: function(print){
                axios.post('/api/booking/BulkGetTickets', {
                    supplierId: this.account.supplierId,
                    bookingIds: this.getBulkSelectedIds,
                    IsToPrint: print? true : false,
                    IsToSendEmail: print? false: true,
                }).then(response => {
                    this.$toasted.info(response.data);
                    this.closeModal();
                })
            },
        },
        components: {
        }
    }
</script>

<style lang="scss" scoped>
    .tckBtn{
        height: 150px;
    }
</style>



// WEBPACK FOOTER //
// areaTickets.vue?f3a2a5d0